export * as demomovies from './default.demomovies'
export * as index from './default.index'
export * as info from './default.info'
export * as transferdetailsmodal from './default.transferdetailsmodal'
